<template>
  <section id="footer" class="footer">
    <div class="footer__info">
      <p class="footer__info-text">
        ООО «Автобан Чери» | ОГРН: 1226600044912 ИНН: 6679154153 | КПП:
        667901001
      </p>
      <div class="footer__policy">
        <span>©{{ new Date().getFullYear() }}</span>
        <a @click="togglePrivacy" role="button">
          Политика обработки персональных данных
        </a>
        <a @click="toggleAgree" role="button"
          >Согласие на обработку персональных данных</a
        >
      </div>
    </div>
    <a @click="expanded = !expanded" class="footer__disclaimer-btn"
      >Дисклеймер</a
    >
    <transition
      name="expand"
      @enter="enter"
      @after-enter="afterEnter"
      @leave="leave"
    >
      <div id="disclaimer" class="footer__disclaimer" v-if="expanded">
        <h3 class="footer__disclaimer-title">Правовая информация</h3>
        <h4 class="footer__disclaimer-title">Общие положения</h4>
        <p class="footer__disclaimer-text">
          Посетители официального Интернет-сайта Группы компаний АВТОБАН
          CHERY (далее – «Сайт») считаются надлежаще ознакомленными и полностью
          принявшими настоящие Правила пользования Сайтом (далее – «Правила»)
          без каких-либо ограничений и оговорок.
        </p>
        <p class="footer__disclaimer-text">
          Группа компаний АВТОБАН оставляет за собой право в одностороннем
          порядке в любое время вносить изменения в настоящие Правила. Сайт
          носит исключительно информационный характер и никакая информация,
          опубликованная на нём, ни при каких условиях не является публичной
          офертой, определяемой положениями пункта 2 статьи 437 Гражданского
          кодекса Российской Федерации. Для получения подробной информации о
          реализуемых товарах, работах и услугах и их цене необходимо обращаться
          к менеджерам торгово-сервисных комплексов Группы компаний АВТОБАН.
        </p>
        <h3 class="footer__disclaimer-title">Продукция и цены</h3>
        <p class="footer__disclaimer-text">
          Сайт содержит информацию об автомобилях, запасных частях, аксессуарах
          и иной продукции, представленной в торгово-сервисных комплексах Группы
          компаний АВТОБАН (далее – «Продукция»), сервисном обслуживании,
          рекламных программах и мероприятиях Группы компаний АВТОБАН.
        </p>
        <p class="footer__disclaimer-text">
          Все содержащиеся на Сайте сведения носят исключительно информационный
          характер и не являются исчерпывающими.
        </p>
        <p class="footer__disclaimer-text">
          казанные на Сайте цены носят исключительно информационный характер,
          могут отличаться от действительных цен в торгово-сервисных комплексах
          Группы компаний АВТОБАН на момент ознакомления Посетителем с ними на
          Сайте.
        </p>
        <p class="footer__disclaimer-text">
          Представленная на Сайте информация, касающаяся комплектаций,
          технических характеристик, внешнего вида, стоимости, условий
          приобретения Продукции, сервисного обслуживания и т. п. может
          отличаться от действительных характеристик и условий приобретения
          продукции в торгово-сервисном комплексе Группы компаний АВТОБАН, а
          также может быть изменена в любое время. Представленная на Сайте
          информация о Продукции не означает, что последняя есть в наличии для
          продажи.
        </p>
        <p class="footer__disclaimer-text">
          Данные о расходе топлива и максимальной скорости получены в идеальных
          условиях, без учета влияния манеры вождения, дорожных и других
          условий, и могут отличаться от реальных. Более подробную и точную
          информацию можно получить в торгово-сервисных комплексах Группы
          компаний АВТОБАН.
        </p>
        <p class="footer__disclaimer-text">
          Ссылки на товары, работы и услуги, реализуемые третьими лицами,
          публикуются в информационных целях и не подразумевают, что Группа
          компаний АВТОБАН их поддерживает или рекомендует.
        </p>
        <h3 class="footer__disclaimer-title">Ссылки на сайты третьих лиц</h3>
        <p class="footer__disclaimer-text">
          Сайт может содержать информацию о сайтах третьих лиц. Переход на любой
          другой Интернет-ресурс по ссылке с Сайта осуществляется на страх и
          риск Посетителя. Группа компаний АВТОБАН не несет ответственности за
          точность информации, сведений, данных, взглядов, советов или
          заявлений, размещенных на этих сайтах. Группа компаний АВТОБАН
          обеспечивает ссылки на другие сайты для удобства Посетителей и это не
          означает, что Группа компаний АВТОБАН одобряет содержание данных
          сайтов или несёт за их содержание ответственность.
        </p>
        <h3 class="footer__disclaimer-title">Интеллектуальная собственность</h3>
        <p class="footer__disclaimer-text">
          Все права на информацию, графические изображения, тексты и иные
          содержащиеся на Сайте материалы и объекты (далее – «Материалы»),
          принадлежат Группе компаний АВТОБАН, а также иным третьим лицам в
          соответствии с условиями договоров, заключенных между Группой компаний
          АВТОБАН и соответствующими третьими лицами.
        </p>
        <p class="footer__disclaimer-text">
          Никакие содержащиеся на Сайте Материалы или их часть не могут быть
          воспроизведены, использованы или переданы третьим лицам в целях
          извлечения прибыли без предварительного согласия Группы компаний
          АВТОБАН в письменной форме. Посетитель может просматривать и
          распечатывать Материалы, содержащиеся на Сайте, для целей личного
          использования или принятия решений о приобретении Продукции и услуг
          Группы компаний АВТОБАН. В се товарные знаки, логотипы, фирменные
          наименования или обозначения (в том числе словесные, графические,
          объемные и другие обозначения или их комбинации), содержащиеся на
          Сайте, являются собственностью Группы компаний АВТОБАН или принадлежат
          ей на праве пользования. Их размещение на Сайте не может
          рассматриваться как разрешение или предоставление прав на их
          использование без предварительного письменного согласия Группы
          компаний АВТОБАН или их правообладателей.
        </p>
        <h3 class="footer__disclaimer-title">Ответственность</h3>
        <p class="footer__disclaimer-text">
          Группа компаний АВТОБАН делает все возможное, чтобы содержащаяся на
          Сайте информация соответствовала действительности. Однако Группа
          компаний АВТОБАН не гарантирует абсолютную точность, полноту или
          достоверность информации, содержащейся на Сайте, не отвечает за
          неточности, возможные ошибки или другие недостатки в размещаемой
          информации, за ее актуальность, а также не гарантирует бесперебойную
          работу Сайта.
        </p>
        <p class="footer__disclaimer-text">
          Группа компания АВТОБАН не несет ответственности за неблагоприятные
          последствия, а также за любые убытки, причиненные вследствие
          ограничения доступа, либо вследствие посещения Сайта и использования
          размещенной на Сайте информации, включая, но, не ограничиваясь,
          убытками за потерю данных и прибыли, а также за убытки, причиненные
          вирусами, нанесшими ущерб компьютерному оборудованию Посетителя.
        </p>
        <h3 class="footer__disclaimer-title">
          Личная информация (персональные данные Пользователя Сайта)
        </h3>
        <p class="footer__disclaimer-text">
          Группа компаний АВТОБАН следует положениям применимого
          законодательства РФ о защите персональных данных.
        </p>
        <p class="footer__disclaimer-text">
          Политика в отношении обработки персональных данных 
          <a href="https://ekt.avtomir.ru/disclaimer/politic/" target="_blank"
            >здесь</a
          >
        </p>
        <p class="footer__disclaimer-text">Группа компаний АВТОБАН.</p>
        <p class="footer__disclaimer-text">
          *Выгода в размере от 10 до 20% от стоимости автомобиля в рамках
          государственных программ льготного автокредитования может
          предоставляться гражданам Российской Федерации, которые являются
          работниками государственных и муниципальных образовательных
          организаций или медицинских организаций государственной системы
          здравоохранения, либо являются военнослужащими, а также членами их
          семей, либо являются пенсионерами, ранее проходившими военную службу.
          Предложение ограничено. Не является офертой и распространяется на
          новые автомобили TENET T4, произведенные в 2025 г., стоимостью не
          более 2 млн. руб. Подробности уточняйте у официальных дилеров TENET и
          у Банков-участников программы льготного автокредитования с
          государственной поддержкой.<br />**Субсидия предоставляется при
          выполнении следующих условий: кредитный договор заключен в
          Банках-участниках программы государственной поддержки в период
          действия государственной программы льготного автокредитования, при
          этом клиент не заключал в году, предшествующем году заключения
          кредитного договора на условиях льготного автокредитования, иных
          кредитных договоров на приобретение автомобиля. Подробности уточняйте
          у официальных дилеров TENET и у Банков-участников программы льготного
          автокредитования с государственной поддержкой.
        </p>
      </div>
    </transition>
  </section>
</template>

<script>
export default {
  name: "FooterComponent",
  data() {
    return {
      expanded: false,
    };
  },
  methods: {
    togglePrivacy() {
      this.emitter.emit("open-privacy", {
        open: false,
      });
    },
    toggleAgree() {
      this.emitter.emit("open-agree-processing", {
        open: false,
      });
    },

    enter(element) {
      const width = getComputedStyle(element).width;

      element.style.width = width;
      element.style.position = "absolute";
      element.style.visibility = "hidden";
      element.style.height = "auto";

      const height = getComputedStyle(element).height;

      element.style.width = null;
      element.style.position = null;
      element.style.visibility = null;
      element.style.height = 0;
      getComputedStyle(element).height;
      requestAnimationFrame(() => {
        element.style.height = height;
      });
    },
    afterEnter(element) {
      element.style.height = "auto";
      element.scrollIntoView({
        behavior: "smooth",
        block: "start",
        inline: "nearest",
      });
    },
    leave(element) {
      const height = getComputedStyle(element).height;

      element.style.height = height;
      getComputedStyle(element).height;

      requestAnimationFrame(() => {
        element.style.height = 0;
      });
    },
  },
  mounted() {
    this.emitter.on("open-privacy", (data) => {
      this.privacyIsHidden = data.open;
    });
    this.emitter.on("open-agree-processing", (data) => {
      this.privacyIsHidden = data.open;
    });
  },
};
</script>

<style lang="scss" scoped>
* {
  will-change: height;
  transform: translateZ(0);
  backface-visibility: hidden;
  perspective: 1000px;
}

.expand-enter-active,
.expand-leave-active {
  transition: height 0.5s ease-in-out;
  overflow: hidden;
}

.expand-enter,
.expand-leave-to {
  height: 0;
}
</style>
